/* Psorelia — comportements UI (galerie, sélecteur d'offre + abonnement, sticky CTA).
   Aucune réécriture de texte des boutons Shopify. Aucun setTimeout de rattrapage. */
(function () {
  'use strict';

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  /* ---------------- Galerie produit : déplacement horizontal uniquement ---------------- */
  function initGallery(scope) {
    var viewport = scope.querySelector('[data-pso-viewport]');
    if (!viewport || viewport.dataset.psoReady === '1') return;
    viewport.dataset.psoReady = '1';

    var thumbs = slice(scope.querySelectorAll('[data-pso-thumb]'));
    var strip = scope.querySelector('[data-pso-thumbs]');
    var ticking = false;
    var index = 0;

    function slideWidth() {
      return viewport.clientWidth || 1;
    }

    function sync() {
      ticking = false;
      var i = Math.round(viewport.scrollLeft / slideWidth());
      if (i < 0) i = 0;
      if (i > thumbs.length - 1) i = thumbs.length - 1;
      if (i === index) return;
      index = i;
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].setAttribute('aria-current', t === index ? 'true' : 'false');
      }
      var active = thumbs[index];
      if (active && strip && strip.scrollWidth > strip.clientWidth) {
        var target = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
        if (Math.abs(strip.scrollLeft - target) > 6) {
          strip.scrollTo({ left: target, behavior: 'smooth' });
        }
      }
    }

    viewport.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(sync);
      }
    }, { passive: true });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        viewport.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      });
    });

    window.addEventListener('resize', function () {
      viewport.scrollLeft = index * slideWidth();
    }, { passive: true });
  }

  /* ---------------- Sélecteur d'offre : quantité + abonnement (selling_plan natif) ----------------
     Achat unique  : le champ `selling_plan` reste disabled, donc absent du POST /cart/add.
     Abonnement    : le champ est activé et reçoit l'id du selling plan choisi.
     Aucun prix n'est calculé ici : tout vient des data-attributs rendus par Liquid. */
  function initOffers(scope) {
    var radios = slice(scope.querySelectorAll('[data-pso-variant]'));
    if (!radios.length || scope.dataset.psoOffersReady === '1') return;
    scope.dataset.psoOffersReady = '1';

    var qtyFields = slice(scope.querySelectorAll('[data-pso-qty-field]'));
    var idFields = slice(scope.querySelectorAll('input[name="id"]'));
    var priceTargets = slice(scope.querySelectorAll('[data-pso-price]'));
    var compareTargets = slice(scope.querySelectorAll('[data-pso-compare]'));
    var planFields = slice(scope.querySelectorAll('[data-pso-plan-field]'));
    var panels = slice(scope.querySelectorAll('[data-pso-plan-panel]'));
    var freqRadios = slice(scope.querySelectorAll('[data-pso-plan]'));

    function showPrices(source) {
      if (!source) return;
      priceTargets.forEach(function (el) {
        el.textContent = source.dataset.price || el.textContent;
      });
      compareTargets.forEach(function (el) {
        var compare = source.dataset.compare || '';
        el.textContent = compare;
        el.hidden = compare === '';
      });
    }

    function setPlan(id) {
      planFields.forEach(function (field) {
        if (id) {
          field.value = id;
          field.disabled = false;
        } else {
          field.value = '';
          field.disabled = true;
        }
      });
    }

    function apply(radio) {
      if (!radio) return;

      if (radio.dataset.qty) {
        qtyFields.forEach(function (field) { field.value = radio.dataset.qty; });
      }
      if (radio.dataset.variantId) {
        idFields.forEach(function (field) { field.value = radio.dataset.variantId; });
      }

      var opens = radio.dataset.psoOpens || '';
      panels.forEach(function (panel) {
        panel.classList.toggle('is-open', opens !== '' && panel.id === opens);
      });

      if (opens === '') {
        setPlan('');
        showPrices(radio);
        return;
      }

      var freq = freqRadios.filter(function (f) { return f.checked; })[0] || freqRadios[0];
      if (freq) {
        freq.checked = true;
        setPlan(freq.dataset.sellingPlan);
        showPrices(freq);
      } else {
        setPlan('');
        showPrices(radio);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) apply(radio); });
    });

    freqRadios.forEach(function (freq) {
      freq.addEventListener('change', function () {
        if (!freq.checked) return;
        setPlan(freq.dataset.sellingPlan);
        showPrices(freq);
      });
    });

    var checked = radios.filter(function (r) { return r.checked; })[0];
    if (checked) apply(checked);
  }

  /* ---------------- Sticky CTA mobile ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-pso-sticky]');
    if (!bar || bar.dataset.psoReady === '1') return;
    bar.dataset.psoReady = '1';

    var anchor = document.querySelector('[data-pso-sticky-anchor]');
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var anchorVisible = true;
    var footerVisible = false;

    function apply() {
      var show = !anchorVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (!('IntersectionObserver' in window)) return;

    if (anchor) {
      new IntersectionObserver(function (entries) {
        anchorVisible = entries[0].isIntersecting;
        apply();
      }, { rootMargin: '-8% 0px -8% 0px' }).observe(anchor);
    } else {
      anchorVisible = false;
    }

    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        apply();
      }, { rootMargin: '0px' }).observe(footer);
    }

    apply();
  }

  function boot(root) {
    var scope = root || document;
    slice(scope.querySelectorAll('[data-pso-gallery]')).forEach(initGallery);
    slice(scope.querySelectorAll('[data-pso-scope]')).forEach(initOffers);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
